// @flow
import { default as stringArgumentProcessor } from "./stringArgumentProcessor";

export default [stringArgumentProcessor];
